import { queryOptions } from '@tanstack/react-query';
import { shiftsGet2 } from '~/generated';
import { extractData } from '~/utils/query-utils';
import type { Turn } from '~/hooks/api/useShift';

const EXPAND_SHIFT_DETAILS = [
  'turns.route',
  'turns.language',
  'turns.turnAssignments.publisherMiniRecord',
];

export const shiftDetailQueryOptions = (id: number) =>
  queryOptions({
    queryKey: ['shifts', id, EXPAND_SHIFT_DETAILS],
    queryFn: () =>
      extractData(
        shiftsGet2({
          path: { id },
          query: { expand: EXPAND_SHIFT_DETAILS },
          responseType: 'json',
        })
      ) as unknown as { id: number; turns: Turn[] },
  });
